import React, { useMemo } from "react";

import { Row, Col } from "antd";
import get from "lodash/get";
import moment from "moment/min/moment-with-locales.min";
import PropTypes from "prop-types";
import Button from "shared/components/Button";
import HtmlViewer from "shared/components/HtmlViewer";
import { DOC_TYPES } from "utils/constants";

import "./styles.scss";

const Component = ({
  data: {
    interventionType,
    creationDate,
    statusDesc,
    statusColor,
    statusComment,
    folderNum,
    productBrand,
    productPhoto,
    productDesc,
    productRef,
    planningDay,
    warrantyDesc,
    extra,
  },
  onClick,
}) => {
  const documentation = useMemo(
    () => get(extra, "workflow.documentation"),
    [extra],
  );
  if (statusComment) {
    // ignore 'statusComment'
  }
  return (
    <div className={"card"} onClick={onClick}>
      <div
        className={"spaced-row padding-row"}
        style={{ backgroundColor: `${statusColor}33` }}>
        <p className={"date"}>
          {moment(creationDate, "DD/MM/YYYY").format("DD.MM.YY")}
        </p>
        <div className={"row"}>
          <Col>
            <Row>
              <p className={"status"}>{statusDesc}</p>
            </Row>
            {planningDay?.date && (
              <Row className="rowPlanningDay">
                <p className={"status"}>
                  {moment(planningDay?.date).format("DD.MM.YY")}
                </p>
              </Row>
            )}
          </Col>
        </div>
      </div>
      <div className={"divider"} />
      <div className={"spaced-row"}>
        <Col>
          <p className={"title"}>{interventionType}</p>
          <p className={"title"}>{warrantyDesc}</p>
        </Col>
        <p className={"title"}>{folderNum}</p>
      </div>
      <div className={"spacer"} />
      <div className={"product-row"}>
        {productPhoto && (
          <img
            src={productPhoto}
            width={64}
            className={"image"}
            alt={"product image"}
            onError={(event) => (event.target.style.display = "none")}
          />
        )}
        <div>
          <p className={"description"}>{productBrand}</p>
          <p className={"description"}>{productDesc}</p>
          {productRef !== productDesc && (
            <p className={"description"}>{productRef}</p>
          )}
        </div>
      </div>
      <div className={"divider"} />
      <div className={"footer"}>
        {documentation &&
          documentation.url &&
          (documentation.docType === DOC_TYPES.PDF ? (
            <Button
              text={"PDF"}
              custom="button-pdf"
              variant="BORDERED"
              onClick={() => window.open(documentation.url)}
            />
          ) : documentation.docType === DOC_TYPES.HTML ? (
            <HtmlViewer url={documentation.url} />
          ) : null)}
      </div>
    </div>
  );
};

Component.propTypes = {
  data: PropTypes.shape({
    interventionType: PropTypes.string,
    creationDate: PropTypes.string,
    productBrand: PropTypes.string,
    statusDesc: PropTypes.string,
    statusColor: PropTypes.string,
    statusComment: PropTypes.string,
    folderNum: PropTypes.string,
    productDesc: PropTypes.string,
    productPhoto: PropTypes.string,
    productRef: PropTypes.string,
    warrantyDesc: PropTypes.string,
    planningDay: PropTypes.shape({
      date: PropTypes.string,
      /* intervals: PropTypes.shape({
        start: PropTypes.string,
        end: PropTypes.string,
      }).isRequired, */
    }).isRequired,
    extra: PropTypes.shape({
      workflow: PropTypes.object,
    }),
  }).isRequired,
  onClick: PropTypes.func.isRequired,
};

export default Component;
